import moment from 'moment'
import React from 'react'
import { formatDate } from '../../../common/helpers'
import DatePicker from './../datePicker'

let searchTimer
let completionTimer

const handlers = {
  closeFilterDateMenu: props => (event, value) => {
    props.setFilterDateMenu(null)

    const range = {
      endDate: null,
      startDate: formatDate()
    }
    let label

    switch (value) {
      case '30':
        range.endDate = formatDate(moment().add(30, 'days'))
        label = '30 days'
        break

      case '60':
        range.endDate = formatDate(moment().add(60, 'days'))
        label = '60 days'
        break

      case '90':
        range.endDate = formatDate(moment().add(90, 'days'))
        label = '90 days'
        break

      case 'thisYear':
        range.startDate = formatDate(`${moment().format('YYYY')}-01-01`)
        range.endDate = formatDate(`${moment().format('YYYY')}-12-31`)
        label = 'This Year'
        break

      case '5year':
        range.endDate = formatDate(moment().add(5, 'years'))
        label = '5 Years'
        break

      case 'custom':
        props.modalOpenDispatch({
          component: (
            <DatePicker
              startDate={props.filter.date ? props.filter.date.startDate : null}
              endDate={props.filter.date ? props.filter.date.endDate : null}
              onSelect={props.setCustomDateRange}
            />
          ),
          isFullWidth: true,
          maxWidth: 'sm',
          title: 'Custom Date Range',
          unsetHeight: true
        })
        break

      default:
        range.endDate = formatDate(moment().add(90, 'days'))
        label = '90 days'
        break
    }

    if (props.registerDateEvent) {
      props.registerDateEvent(label)
    }

    props.setFilter('date', range)
    props.setFilterDateLabel(label)
  },

  closeFilterLocaleMenu: props => (event, index) => {
    props.setFilterLocaleMenu(null)

    // If clicked off menu: only close menu, do not change anything
    if (index === 'backdropClick') {
      return
    }

    let locale = null

    if (index !== undefined) {
      locale = props.stateList[index]
      props.setFilterLocaleLabel(locale.name)
    } else {
      props.setFilterLocaleLabel(null)
    }
    props.setFilter('locale', locale)
  },

  handleExports: props => (event, exportType) => {
    if (props.onExport) {
      props.onExport(exportType)
    }
  },

  handleSearch: props => event => {
    let value = event.target.value
    handleSearchEvent(value, props)
  },

  openFilterDateMenu: props => event => {
    props.setFilterDateMenu(event.currentTarget)
  },

  openFilterLocaleMenu: props => event => {
    props.setFilterLocaleMenu(event.currentTarget)
  },

  handleLocationAdd: props => event => {
    props.modalOpenDispatch({
      component: <LocationAddForm />,
      title: 'Add Location',
      isFullWidth: false,
      maxWidth: 'md'
    })
  }
}

const handleSearchEvent = (value, props) => {
  clearTimeout(searchTimer)
  clearTimeout(completionTimer)

  searchTimer = setTimeout(() => {
    props.setFilter('search', value)
  }, 300)

  if (props.onSearchFinished && value) {
    completionTimer = setTimeout(() => {
      props.onSearchFinished(value)
    }, 1000)
  }
}

export default handlers
